const NAME = 'property';

const SECTIONS = {
  ACTIVITY: 'activity',
  ACCESS: 'access',
  CALENDAR: 'calendar',
  REQUIREMENTS: 'requirements',
  INTEGRATIONS: 'integrations',
  ABOUT_NOTES: 'notes',
  ABOUT_OWNERS: 'owners',
  INTEGRATIONS_ICAL: 'integrations iCal',
};

const CALENDAR_DATE_SWITCH_VARIANTS = {
  PREVIOUS: 'previous',
  CURRENT: 'current',
  NEXT: 'next',
};

export const ELEMENT_CODES_TO_ICONS_MAP = {
  bathroom: 'e-bathroom',
};

export default { CALENDAR_DATE_SWITCH_VARIANTS, NAME, SECTIONS };
